import { Quill } from "vue-quill-editor";
// import "./dist/quill.core.css";    // テーマ固定なら不要
import "./dist/quill.snow.css";       // ツールバーを表示するテーマ
// import "./dist/quill.bubble.css";  // テーマ固定なら不要
import { default as Parchment } from "parchment";
import { AttributorOptions } from "parchment/dist/src/attributor/attributor";
import { default as StyleAttributor } from "parchment/dist/src/attributor/style";
import { default as ClassAttributor } from "parchment/dist/src/attributor/class";

export function load() {
  // Quillですべてのフォントサイズ・フォント指定を許容する指定
  // https://github.com/quilljs/quill/issues/1188
  const sizeStyle = Quill.import("attributors/style/size") as StyleAttributor;
  sizeStyle.whitelist = null;
  Quill.register(sizeStyle, true);
  
  const fontStyle = Quill.import("attributors/style/font") as StyleAttributor;
  fontStyle.whitelist = null;
  Quill.register(fontStyle, true);
  
  // Quillでalign-leftに明示的に変更できるようにする指定
  const align = Quill.import("attributors/class/align") as ClassAttributor;
  align.whitelist = null;
  Quill.register(align, true);

  const icons = Quill.import("ui/icons");
  icons.align.left = icons.align[""];
  Quill.register(icons, true);

  // Quillでline-spaceを変更できるようにする指定
  const parchment = Quill.import("parchment") as typeof Parchment;
  const lineSpaceConfig: AttributorOptions = {
    scope: Parchment.Scope.BLOCK,
    whitelist: null,
  };
  Quill.register({
    "attributors/class/linespace": new parchment.Attributor.Class("linespace", "ql-linespace", lineSpaceConfig)
  }, true);
  Quill.register({
    "formats/linespace": new parchment.Attributor.Attribute("linespace", "data-line-space", lineSpaceConfig)
  }, true);
}
